<script setup lang="ts">
    import {UploaderI18n} from "../types/I18n";
    import {UploadFile} from "../types/UploadFile";
    import { type PropType } from 'vue'

    const props = defineProps({
        i18n: {
            type: Object as PropType<UploaderI18n>,
            required: true
        },
        doResize: Boolean
    })

    const emit = defineEmits(['addFileCallback'])

    const addFiles = (event: InputEvent) => {
        const target = event.target as HTMLInputElement
        let newFiles = target.files || event.dataTransfer.files;
        for (let i = 0; i<newFiles.length; i++) {
            let uploadFile : UploadFile  =  {
                localFile: newFiles[i],
                name: newFiles[i].name,
                doResize: props.doResize
            }
            emit('addFileCallback', uploadFile);
        }
    }
</script>

<template>
    <label for="fileselect">{{props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_FILES_TO_UPLOAD}}:</label>
    <br />
    <input id="fileselect"
type="file"
multiple="multiple"
@change="addFiles"/>
</template>

<style scoped lang="less">

</style>